import IconButton from '@/components/ui/custom/buttons/IconButton';
import Text from '@/components/ui/custom/dataDisplay/Text';
import { useUpvoting } from '@/components/projects/cards/Interactions.hooks';
import useManualSingleQuery from '@/data/hook/query/v1/useManualSingleQuery';
import { projectsQuerykeys } from '@/data/services/querykeys';
import { Project } from '@/models/Project';
import { HeartIcon, EyeIcon } from '@heroicons/react/24/outline';
import { HeartIcon as SolidHeartIcon } from '@heroicons/react/20/solid';
import { useTranslation } from 'react-i18next';

const ProjectInteractions = ({ project }: { project: Project }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'projects.view',
  });
  const { upVoted, upVotes, views } = project;
  const { set } = useManualSingleQuery(projectsQuerykeys.get(project.id));
  const { upVote, isUpvoting } = useUpvoting(project, set);
  const UpVotedIcon = upVoted ? SolidHeartIcon : HeartIcon;

  return (
    <div className="flex justify-between w-full">
      <div className="flex gap-1 items-center">
        <EyeIcon className="w-5 h-5 text-primary" />
        <Text
          text={t('views', {
            count: views,
          })}
        />
      </div>
      <div className="flex gap-1 items-center">
        <IconButton
          className="w-5 h-5 text-error"
          loading={isUpvoting}
          icon={<UpVotedIcon />}
          onClick={() => upVote()}
        />
        <Text
          text={t('likes', {
            count: upVotes,
          })}
        />
      </div>
    </div>
  );
};

export default ProjectInteractions;
